import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { useHistory, withRouter, Link } from "react-router-dom"

import { getToken,IsModemAccess } from '../../helpers/helper';
import {del,post} from '../../helpers/api_helper';
import { POST_GET_ALL_COUNTRY,DELETE_COUNTRY,POST_UPDATE_STATUS_COUNTRY } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom';
 
import $ from 'jquery'; 
import "datatables.net-dt/js/dataTables.dataTables";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"


const UserProfile = props => {
    let history = useHistory();
    const [country_id, SetCountryId] = useState(0);

    useEffect(() => {
        get_list();
    }, [])

    // get list
    const get_list = () => {
        $(document).ready(function () {
            $('#dataTableExample').DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": true,
                "sServerMethod": "POST",
                "sAjaxSource": POST_GET_ALL_COUNTRY,
                "order": [[0, 'desc']],
                columnDefs: [{ orderable: false, targets: [6,7] }, { "targets": 0, "visible": false }],
                "fnServerData": function (sSource, aoData, fnCallback) {
                    $.ajax({
                        "dataType": 'json',
                        "type": "POST",
                        "url": sSource,
                        "data": aoData,
                        "success": fnCallback,
                        headers: { 'Authorization': getToken() },
                    });
                },
                "columns": [
                    { "data": "country_id" },
                    { "data": "country_name" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                {data.country_code && <div className="text-center"><span className="country_flags"><img src={`/flags/${data.country_flags}.png`} alt={data.country_name} title={data.country_name} style={{'maxWidth' : '25px' ,'maxHeight': '25px'}} /> </span></div> }
                                {!data.country_code && <span>-</span> }
                            </>, td)
                        }
                    },
                    { "data": "country_code" },
                    { "data": "phone_code" },
                    { "data": "total_user" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                {data.country_stauts === 1 && <button onClick={UpdateStatus.bind(this,data.country_id,data.country_stauts)}  className="border-0 badge badge-success fs-6"  >Active</button>}
                                {data.country_stauts === 0 && <button onClick={UpdateStatus.bind(this,data.country_id,data.country_stauts)} className="border-0 badge badge-danger fs-6" >Deactive</button>}
                            </>, td)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                {IsModemAccess('country','edit') && <button className="btn btn-soft-success waves-effect waves-light p-1 mr-2" onClick={() => { history.push('/edit-country/' + data.country_id); }} ><i className="bx bx-edit align-middle"></i></button>}
                                {IsModemAccess('country','delete') && <button className="btn btn-soft-danger waves-effect waves-light p-1 mr-2" onClick={() => { SetCountryId(data.country_id); }} data-toggle="modal" data-target="#deleteModal" ><i className="bx bx-trash-alt align-middle"></i></button>}
                            </>, td)
                        }
                    },
                ]
            });
        });
    }

    // remove user role
    const remove_row = async() => {
        var res_data =  await del(DELETE_COUNTRY+"?country_id="+country_id);
        if(res_data.status){
            toast(res_data.message);
            get_list();
        }else{
            toast.error(res_data.message);
        }
    }

    //UpdateStatus
    const UpdateStatus = async(country_id,status) => {
        if(!IsModemAccess('country','edit')){
            toast('Does not permission this module');
        }
        var res_data =  await post(POST_UPDATE_STATUS_COUNTRY,{country_id:country_id,status:status});
        if(res_data.status){
            toast(res_data.message);
            get_list();
        }else{
            toast.error(res_data.message);
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Country | Free Money Coins</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumb title="Dashboard" breadcrumbItem="Country" />

                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h5>Country List</h5>
                                        </div>
                                        <div className="col-sm-6 text-end">
                                        {IsModemAccess('country','add') && <Link to="add-country" className="btn btn-primary btn-sm w-xs">+ Add</Link>}
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="mt-4 mb-5">
                                    {IsModemAccess('country','view') &&
                                        <table id="dataTableExample" className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <td>Id</td>
                                                    <td>Name</td>
                                                    <td>Code Flag</td>
                                                    <td>Code</td>
                                                    <td>Phone Code</td>
                                                    <td>Total User</td>
                                                    <td>Status</td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                            </tbody>
                                        </table>}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm Delete</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this record?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">No</button>
                            <button onClick={remove_row.bind(this)} data-dismiss="modal" className="btn btn-primary">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>

    )
}

export default withRouter(UserProfile)
